var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.9773C0 7.15328 7.15328 0 15.9773 0C24.797 0.0104049 31.9442 7.1576 31.9546 15.9773C31.9546 24.8013 24.8013 31.9546 15.9773 31.9546C7.15328 31.9546 0 24.8013 0 15.9773ZM2.90496 15.9773C2.90496 23.197 8.75765 29.0496 15.9773 29.0496C23.1933 29.0408 29.0408 23.1933 29.0496 15.9773C29.0496 8.75765 23.197 2.90496 15.9773 2.90496C8.75765 2.90496 2.90496 8.75765 2.90496 15.9773Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M23.239 14.5248H17.4291V8.71489C17.4291 7.9127 16.7788 7.26241 15.9766 7.26241C15.1744 7.26241 14.5241 7.9127 14.5241 8.71489V14.5248H8.7142C7.91202 14.5248 7.26172 15.1751 7.26172 15.9773C7.26172 16.7795 7.91202 17.4298 8.7142 17.4298H14.5241V23.2397C14.5241 24.0419 15.1744 24.6922 15.9766 24.6922C16.7788 24.6922 17.4291 24.0419 17.4291 23.2397V17.4298H23.239C24.0412 17.4298 24.6915 16.7795 24.6915 15.9773C24.6915 15.1751 24.0412 14.5248 23.239 14.5248Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add.7f75ad28156d31607908714ce976685f.svg";